import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-validator', () => import(/* webpackMode: "lazy" */'./form-validator'));
